module.exports = __webpack_public_path__ + "static/media/arrowDown.37f3f3cd.svg";